import React, { useEffect } from "react";
import DetailHomme from "../components/categorieHommePage/DetailHomme";
import HomeFooter from "@/components/homePage/HomeFooter";
import HomeFooter2 from "@/components/homePage/HomeFooter2";
import HomeHeader2 from "@/components/homePage/HomeHeader2";
export default function Homme({ paniernbr, acces }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <HomeHeader2 acces={acces} paniernbr={paniernbr} />
      <DetailHomme acces={acces} paniernbr={paniernbr} />
      <HomeFooter2 />
    </>
  );
}
